import { forwardRef } from "react";
import type { HTMLAttributes } from "react";

export type MapCanvasProps = HTMLAttributes<HTMLDivElement>;

export const MapCanvas = forwardRef<HTMLDivElement, MapCanvasProps>(function MapCanvas({ className, ...rest }, ref) {
  return <div {...rest} ref={ref} className={["fxmap-canvas", className ?? ""].filter(Boolean).join(" ")} data-fxmap="canvas" />;
});
